import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: false,
}

export const mouseOnVehicle = createSlice({
    name: 'mouseOnVehicle',
    initialState,
    reducers: {
        addBool: (state, action) => {
            state.value = (action.payload);
        },
    },
})

// Action creators are generated for each case reducer function
export const { addBool } = mouseOnVehicle.actions

export default mouseOnVehicle.reducer